
// ROUTES
require('modules/workshop/routes/workshop');

// CONTROLLERS
require('modules/workshop/controllers/workshop');
require('modules/workshop/controllers/list');
require('modules/workshop/controllers/create');
require('modules/workshop/controllers/edit');
require('modules/workshop/controllers/registered');

// SERVICES
require('modules/workshop/services/workshop');
require('modules/workshop/services/list');
require('modules/workshop/services/create');
require('modules/workshop/services/edit');
require('modules/workshop/services/delete');


angular.module('unica_workshop', [

	// ROUTES
	'unica_workshop.workshop_routes',

	// CONTROLLERS
	'unica_workshop.workshop_controllers',

	// SERVICES
	'unica_workshop.workshop_services'

]);